import { render } from "./ZapiStockBadge.vue?vue&type=template&id=04145f10&scoped=true"
import script from "./ZapiStockBadge.vue?vue&type=script&lang=js"
export * from "./ZapiStockBadge.vue?vue&type=script&lang=js"

import "./ZapiStockBadge.vue?vue&type=style&index=0&id=04145f10&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04145f10"]])

export default __exports__